import script from "./Template2.vue?vue&type=script&setup=true&lang=js"
export * from "./Template2.vue?vue&type=script&setup=true&lang=js"

import "./Template2.vue?vue&type=style&index=0&id=75cade24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cade24"]])

export default __exports__